import { ApryseSDK } from '../../pdf/ApryseSDK';
import { GlobalDialogs } from '../../pdf/GlobalDialogs';
import { GlobalVariables } from '../../pdf/GlobalVariables';
import Command from './_Command';

export default class GoToPageController extends Command {
    constructor(private readonly direction: string, private readonly path: string | false) {
        const key = `page${direction}`;

        GlobalVariables.registeredCommands[key] = () => {
            if (GlobalDialogs.isDialogShown) {
                return;
            }

            const index =
                ApryseSDK.documentViewer.getCurrentPage() + (direction === 'Down' ? 1 : -1);
            ApryseSDK.documentViewer.setCurrentPage(index, true);
        };

        super({
            Enabled: true,
            Key: key,
            Path: path,
            Callback: GlobalVariables.registeredCommands[key],
        });
    }
}
